import { createContext, useContext, useState } from 'react';
import type { ContentVersion } from '../character/content/sources';

// Which version of expansion content to show. Hope & Fear (final) is the only one
// offered: there is no HF / Void switch, so an old saved Void choice is ignored.
type ContentVersionValue = [ContentVersion, (v: ContentVersion) => void];

const ContentVersionContext = createContext<ContentVersionValue>(['hf', () => {}]);

export function ContentVersionProvider({ children }: { children: React.ReactNode }) {
  const [version, setVersion] = useState<ContentVersion>('hf');

  return (
    <ContentVersionContext.Provider value={[version, setVersion]}>
      {children}
    </ContentVersionContext.Provider>
  );
}

export const useContentVersion = () => useContext(ContentVersionContext);
